import {RoundTypeResponseBody} from '@dms/api/shared';

export const roundTypeResponseMock: RoundTypeResponseBody[] = [
  {
    key: 'UP',
    value: 'Up',
  },
  {
    key: 'DOWN',
    value: 'Down',
  },
  {
    key: 'ALGEBRAIC',
    value: 'Algebraic',
  },
];
